import React from 'react'
import { styled, SxProps } from '@mui/material/styles'

export const IconWrapper = styled('div')(() => ({
  display: 'inline-block',
  transition: 'all 0.2s linear',
}))

export const Image = styled('img')(() => ({
  display: 'block',
  width: '100%',
  verticalAlign: 'middle',
  //   transform: "translateX(-50%)",
  //   objectFit: "contain",
}))

export interface ImageIconProps {
  src: string;
  className?: string;
  sx?: SxProps;
  id?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const ImageIcon: React.FC<ImageIconProps> = (props) => {
  const { src, className, sx, id, onClick } = props
  return (
    <IconWrapper className={className} sx={sx} id={id} onClick={onClick}>
      <Image src={src} loading="lazy" />
    </IconWrapper>
  )
}
